import styles from './style.module.scss';
import HoverCollapsibleSection from 'components/collapsible';
import { Add, Remove } from '@mui/icons-material';
import { FaqItem } from '@tenants';
import HtmlTrans from 'components/html-trans';
import { useTranslation } from 'next-i18next';

const faqCollapsedIcon = () => {
  return (
    <div className={styles['toggle-icon']}>
      <Add />
    </div>
  );
};

const faqExpandedIcon = () => {
  return (
    <div className={styles['toggle-icon']}>
      <Remove />
    </div>
  );
};

type JoinExpFaqProps = {
  readonly title: string;
  readonly items: readonly FaqItem[];
  disableHoverExpansion?: boolean;
};

function JoinExpFaq({ title, items, disableHoverExpansion = true }: JoinExpFaqProps) {
  const { t } = useTranslation();
  if (!items || items.length === 0) {
    return null;
  }

  const content = items.map(item => ({
    title: t(item.title),
    children: <HtmlTrans
      t={t}
      i18nKey={item.children}
      styleOverrides={item.styleOverrides}
      values={item.values}
    />,
  }));

  return (
    <div className={styles.component} id='join-exp-faq'>
      <h2>{t(title)}</h2>
      <HoverCollapsibleSection
        items={content}
        isHoverable={!disableHoverExpansion}
        disableGutters
        className={styles['faq-content']}
        headerClassName={styles['faq-header']}
        detailsClassName={styles['faq-details']}
        iconOverride={{
          expandedIcon: faqExpandedIcon(),
          collapsedIcon: faqCollapsedIcon(),
        }}
      />
    </div>
  );
}

export default JoinExpFaq;